import React, { FunctionComponent, useEffect } from 'react';

import { ChooseContainer } from 'src/components/choose-container';
import { i18n } from 'src/i18n';
import { selectAccountActionCreator } from 'src/state/account/action-creators/select-account-action-creator';
import { selectAccounts } from 'src/state/account/selectors';
import { getRequest } from 'src/state/request/selectors';
import { RequestStatus, RequestType } from 'src/state/request/types';
import { useAppDispatch, useAppSelector } from 'src/state/thunk-api';

import { ChooseAccountButton } from './choose-account-button';

export const PageChooseAccount: FunctionComponent = () => {
  const accounts = useAppSelector(selectAccounts);
  const accountsRequest = useAppSelector(getRequest(RequestType.GET_ACCOUNTS));
  const partnersRequest = useAppSelector(getRequest(RequestType.GET_PARTNERS));
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (
      accountsRequest.status === RequestStatus.SUCCESS &&
      partnersRequest.status === RequestStatus.SUCCESS &&
      accounts.length === 1
    ) {
      dispatch(selectAccountActionCreator(0));
    }
  }, [accountsRequest, partnersRequest, accounts, dispatch]);

  return (
    <ChooseContainer title={i18n.page.chooseAccount.title} subtitle={i18n.page.chooseAccount.description}>
      {accounts.map((account, index) => (
        <ChooseAccountButton key={account.customerId} index={index} account={account} />
      ))}
    </ChooseContainer>
  );
};
